module.exports = __webpack_public_path__ + "assets/img/aperture.fde887f4.svg";